import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedHTMLMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { get } from 'lodash'
import { Title } from 'components/misc'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import { COLORS } from 'constants/layout/section-colors'
import styles from './notification-item.styl'
import { getPraiseDescription } from '../../../helpers/notificationHelper'

export default class NotificationItem extends Component {
  static propTypes = {
    data: PropTypes.object
  }


  getDescription = notification => {
    const isPraise = get(notification, 'isPraise')

    const isSystem = get(notification, 'isSystem')

    const authorName = get(notification, 'author.name')

    if (isPraise) {
      return getPraiseDescription(notification)
    }

    if(!isPraise && !isSystem){
      return (<FormattedHTMLMessage
        id="label.notification_message_description"
        defaultMessage="{authorName} sends a message:"
        values={{ authorName: authorName }}
      />)
    }

  return ''
  }

  getTitleColor = (activitySection, isMessage) =>{
    if (isMessage) {
      return COLORS.pastelpurple.value
    }

    return activitySection
      ? getActivityClassName(activitySection)
      : COLORS.blue.value
  }

  getContent = notification => {
    const isPraise = get(notification, 'isPraise')

    const isSystem = get(notification, 'isSystem')

    if (isPraise) {
      return (<div>
        <div className={styles.praisedLog}>
          <p>{get(notification, 'activityLog.description')}</p>
      </div>

      <div className={styles.clear}></div>

        <div className={styles.praiseIcon}>
          <i className={`ico ico--face ${styles.ico}`} />
        </div>
        <div className={styles.praise}>
          <p>
            <FormattedHTMLMessage id='label.translation_message' defaultMessage={get(notification, 'translationMessage')} />
          </p>
        </div>
        <div className={styles.clear}></div>
      </div>)
    } else if (!isPraise && !isSystem) {
      return (<div className={styles.messageWrapper}>
                <div className={styles.praiseIcon}>
                  <i className={`ico ico--face ${styles.ico}`} />
                </div>
                <div className={styles.praise}>
                <p>
                  <FormattedHTMLMessage id='label.translation_message' defaultMessage={get(notification, 'translationMessage')} />
                </p>
              </div>
              <div className={styles.clear}></div>
            </div>)
    }else {
      return (<p className={styles.message}>
        {get(notification, 'note')
          ? <span>
              <FormattedHTMLMessage id='label.reason' defaultMessage='reson' />
                :
            {' '}
            <em>{get(notification, 'note')}</em>
            </span>
          :    <FormattedHTMLMessage id='label.translation_message' defaultMessage={get(notification, 'translationMessage')} />}
      </p>)
    }
  }


  render() {
    const { data } = this.props

    const activitySection = get(data, 'activitySection.value')

    const isPraise = get(data, 'isPraise')

    const isSystem = get(data, 'isSystem')

    const isDescriptionShow = (isPraise || !isSystem)

    const isMessage = (!isPraise && !isSystem)

    const colorClass = this.getTitleColor(activitySection, isMessage)

    return (
      <div className={styles.item}>

        <div className={styles.top}>
          <Title
            h4
            colorClass={colorClass}
            style={{
              marginBottom: '0',
              lineHeight: '2.4rem',
              fontSize: '1.6rem',
              float: 'left'
            }}
          >
            {get(data, 'translationTitle')}
          </Title>
          <p className={styles.date}>
            <FormattedDate
              value={get(data, 'creationDate')}
              year='numeric'
              month='numeric'
              day='numeric'
            />
          </p>
        </div>
        <div className={styles.clear}></div>
        { isDescriptionShow && <div className={styles.description}><p>{this.getDescription(data)}</p></div>}
        <div className={styles.content}>
        {this.getContent(data)}
        </div>
      </div>
    )
  }
}
